import React from 'react';
import { ArrowUpRightIcon } from 'lucide-react';
import { Halo, RuleDot } from './Decor';
const questions = ['¿Cómo registro mi empresa?', '¿Necesito un EIN?', '¿Qué necesito para verme profesional?', '¿Necesito logo, dominio o página web?', '¿Qué debería hacer primero?'];
export function Problem() {
  return <section aria-labelledby="problema-titulo" className="relative overflow-hidden bg-lavender-50" data-id="element-197" data-mp="2gdhk73ils0t5">
      <Halo soft className="-left-32 top-10 h-[26rem] w-[26rem]" data-id="element-198" data-mp="21p4om7nfgjz6" />

      <div className="relative mx-auto max-w-content px-5 py-14 sm:px-8 sm:py-20 lg:py-28" data-id="element-199" data-mp="26h69ghynvj0t">
        <div className="grid gap-9 lg:grid-cols-[minmax(0,0.9fr)_minmax(0,1.1fr)] lg:gap-20" data-id="element-200" data-mp="1sprnq3ddd3q2">
          <div className="lg:sticky lg:top-28 lg:self-start" data-id="element-201" data-mp="1wqjves6lf0k8">
            <RuleDot data-id="element-202" data-mp="1woqp5dzw6icr" />
            <h2 id="problema-titulo" className="mt-5 font-display text-[1.7rem] leading-[1.16] text-plum-900 sm:text-4xl lg:text-[2.7rem]" data-id="element-203" data-mp="1ir22c0m9l152">
              Empezar un negocio puede sentirse complicado.
              <span className="block text-plum-500" data-id="element-204" data-mp="t8vtt8o0dxoa">No tiene que serlo.</span>
            </h2>
            <p className="mt-4 max-w-md text-[1rem] leading-relaxed text-muted sm:mt-6 sm:text-[1.0625rem]" data-id="element-205" data-mp="o9sm1ggn9dcm">
              Tienes la idea, pero empiezan las preguntas:
            </p>
          </div>

          <div data-id="element-206" data-mp="xcldpktqnr2z">
            <ul className="border-t border-lavender-200/80" data-id="element-207" data-mp="xc1ve306f0of">
              {questions.map((question, index) => <li key={question} className="border-b border-lavender-200/80" data-id="element-208" data-mp="9m7mfwiz9w9g" data-mpi={index}>
                  <div className="group flex cursor-default items-center gap-4 rounded-xl px-2 py-3.5 transition-[background-color,transform] duration-200 ease-premium hover:bg-ivory/70 sm:gap-6 sm:px-4 sm:py-5 lg:hover:translate-x-1.5" data-id="element-209" data-mp="5lxeiebmkvry">
                    <span className="w-6 shrink-0 text-[0.7rem] font-medium tracking-[0.14em] text-lavender-300 transition-colors duration-200 ease-premium group-hover:text-plum-600" data-id="element-210" data-mp="3n0ufa0gv0sp3">
                      {String(index + 1).padStart(2, '0')}
                    </span>
                    <span className="flex-1 font-display text-[1.05rem] leading-snug text-plum-900 sm:text-xl" data-id="element-211" data-mp="1lycqh6595my8">
                      {question}
                    </span>
                    <ArrowUpRightIcon className="h-4 w-4 shrink-0 text-lavender-300 transition-colors duration-200 ease-premium group-hover:text-plum-700" strokeWidth={1.6} aria-hidden="true" data-id="element-212" data-mp="1vph70aaktfv6" />
                  </div>
                </li>)}
            </ul>

            <p className="mt-7 max-w-lg font-display text-[1.15rem] leading-snug text-plum-800 sm:mt-9 sm:text-2xl" data-id="element-213" data-mp="1cxy403gjy1t5">
              En Inkova te ayudamos a poner cada pieza en el orden correcto.
            </p>
          </div>
        </div>
      </div>
    </section>;
}